import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Paper,
  Divider,
} from "@mui/material";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DetailItem from "../../../../Components/DetailItem";

const CustomerDetailsSection = ({ orderData }) => {
  return (
    <Grid item xs={12}>
      <Accordion elevation={2} defaultExpanded={false}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            backgroundColor: "primary.50",
            "&:hover": { backgroundColor: "primary.100" },
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <PersonOutlineOutlinedIcon color="primary" />
            <Typography variant="h6">Customer Details</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ p: { xs: 2, md: 3 }, bgcolor: "#f9f9f9" }}>
          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              borderRadius: "12px",
              border: "1px solid #e0e0e0",
              transition: "all 0.3s ease",
              "&:hover": {
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                borderColor: "primary.light",
              },
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <DetailItem label="Name" value={orderData?.customerName} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DetailItem
                  label="Code"
                  value={orderData?.customerCode}
                  copyable={true}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DetailItem
                  label="Email"
                  value={orderData?.customerEmail}
                  copyable={true}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DetailItem
                  label="Phone"
                  value={orderData?.customerPhone}
                  copyable={true}
                />
              </Grid>
              <Grid item xs={12}>
                <Box
                  sx={{
                    p: 2,
                    backgroundColor: "grey.50",
                    borderRadius: "8px",
                    border: "1px solid",
                    borderColor: "grey.300",
                  }}
                >
                  <DetailItem
                    label="Delivery Address"
                    value={orderData?.deliveryAddress}
                    multiline={true}
                    copyable={true}
                  />
                </Box>
              </Grid>
            </Grid>
          </Paper>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default CustomerDetailsSection;
